// ハイライト発言: back yakureki.YakurekiEvent.highlights (JSONField) に対応する domain 型。
// schema は nasu-patient-app と共通 (id / speaker / text / span_sec / citation_id / created_at)、
// speaker enum のみ薬剤師業界用に翻案 (doctor → pharmacist)。

export type HighlightSpeaker = 'pharmacist' | 'patient' | 'other'

export const HIGHLIGHT_SPEAKER_LABEL: Record<HighlightSpeaker, string> = {
  pharmacist: '薬剤師',
  patient: '患者',
  other: 'その他',
}

export interface Highlight {
  id: string
  speaker: HighlightSpeaker
  text: string
  span_sec: number
  citation_id: string
  created_at: string
  // 未確定 (interim) 由来の暫定ハイライト。確定後の dispatch で確定版に置換される。
  // front では italic + muted で「まだ確定していない」ことを示す。
  is_interim?: boolean
}
